export var InventoryInitializationActionTypes;
(function (InventoryInitializationActionTypes) {
    InventoryInitializationActionTypes["INVENTORY_SET_GLOBAL_STATE"] = "INVENTORY_SET_GLOBAL_STATE";
    InventoryInitializationActionTypes["INVENTORY_INITIALIZE"] = "INVENTORY_INITIALIZE";
})(InventoryInitializationActionTypes || (InventoryInitializationActionTypes = {}));
